import { iconCategoryCssClass } from "../../data/utils";

export default function ScrollerEvent(props) {
    const data = props.data;
    const categoryIcon = iconCategoryCssClass(data.sportRef, data.categoryRef, data.categoryIcon);

    return (
        <div className="c_37_2_1" onClick={() => props.add(data)}>
            <div className="c_37_2_1_1">
                <div className={"c_37_2_1_1_1 " + categoryIcon}></div>
                <div className="c_37_2_1_1_2">{data.categoryDesc} | {data.tournamentDesc}</div>
            </div>
            <div className="c_37_2_1_2">
                <div className="c_37_2_1_2_1">{data.score?.periodo}</div>
                <div className="c_37_2_1_2_2">{data.team1}</div>
            </div>
            <div className="c_37_2_1_2">
                <div className="c_37_2_1_2_1">{data.score?.currentMinute}</div>
                <div className="c_37_2_1_2_2">{data.team2}</div>
            </div>
        </div>
    );
}
